import { Component, Input } from '@angular/core'

@Component({
  selector: 'bdg-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent {
  @Input() icon: string

  @Input() label: string

  @Input() disabled = false

  @Input() xPosition: 'after' | 'before' = 'before'

  @Input() yPosition: 'above' | 'below' = 'below'
}
